import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import './Header.css';

export default function Layout() {
    const token = localStorage.getItem('token');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

    useEffect(() => {
        const handleResize = () => {
            const desktop = window.innerWidth >= 992;
            setIsDesktop(desktop);
            if (desktop) setSidebarOpen(false);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (!token) {
        return <Outlet />;
    }

    return (
        <div className="d-flex flex-column min-vh-100">
            <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
            <div className="d-flex flex-grow-1">
                <main className={`app-main mpa-layout-main ${isDesktop ? 'app-main--with-sidebar' : ''}`}>
                    <div className="app-content">
                        <Outlet />
                    </div>
                </main>
            </div>
            {isDesktop && <Footer />}
        </div>
    );
}
